<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-area {
  margin-top: 20px;
}
</style>

<template>
  <div>
    <dimension-dialog v-if="showExport" @hideExport="hideExport1" tabNames="monthly"  :moduleName="moduleName"/>
    <detailsData
        v-if="showDetails"
        :year="year"
        :value="value4"
        :provinName="provinName"
        :provinCode="provinCode"
        :dimObj="getNewDimObj()"
        :month="month"
        :fuelType="fuelType"
        @closeDetails="closeDetails"
    />
    <div class="home-main" v-else>
      <div class="mark" v-if="mark">
        <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
      </div>
      <tabTon :titleArr="titleArr" :changeType="changeType" :path="path" :dataType="dataType">

        <el-button v-show="hideExport" style="float: right;margin-right: 10px;margin-top: 26px;" @click="exportDate">
          导出
        </el-button>
        <el-select v-model="fuelType" @change="changeFuelType"
                   style="width:150px;float: right;margin-right: 10px;margin-top: 26px;" placeholder="请选择燃油类型">
          <el-option
              v-for="(item,index) in fuelTypeList"
              :label="item.label"
              :value="item.value"
              :key="index"
          />
        </el-select>
      </tabTon>
      <div class="map-data">
        <div class="map-area">
          <div style="position: absolute;left: 40%;top: -5px;z-index:100;">
            <dimension-popover ref="objDimensionPopover" tabNames="monthly" :isMapValue="true" :dimObj="dimObj" :change="changeDimension"
                               :showBottomButton="false" :isItemBindClick="true"/>
          </div>
          <!--          :year="year"-->
          <!--          :month="month"-->
          <home-map
              :dataType="dataType"
              :title="titleArr[dataType].title"
              :mapRangeList="mapRangeList"
              :dataItem="dataItem"
              :priviceName="priviceName"
              @getDetails="getDetails"
          ></home-map>
          <mapBox v-if="showtip"/>
        </div>
        <map-card :cardItem="dataItem" @getDetails="getDetails"></map-card>
      </div>
    </div>
    <div class="bottom-top" v-if="!showDetails">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>
        1.入网车辆数：按照车籍地统计截至当月的属地化（省/市/自治区）车辆数，例如：京A12345统计到北京，沪A12345统计到上海，冀A12345统计到河北。可反映当地重载货车保有量、燃料类型构成、吨位分布。【注】本平台主要统计为12吨及以上的重载普货及半挂牵引车、少量10吨以下的货车。不包括“两客一危”车辆、非营运车辆（如工地的工程车、港口园区内的摆渡车辆、市政的特种运输车辆等）。
      </div>
      <div>2.吨位划分：以入网车辆总质量的吨位数进行区间划分。</div>
      <div>3.统计频率：按月统计，每月6日更新截至上月数据。</div>
      <div>4.下一级页面：点击地图对应省份或者右侧省份名称，可进入该省各地区入网车辆吨位分布统计页面。</div>
    </div>
  </div>
</template>

<script>
import homeMap from './components/map.vue'
import detailsData from './components/details.vue'
import mapCard from './components/mapCard.vue'
import tabTon from '../component/tabTon.vue'
import {getFuelTypeList, getFuelTypeCode} from '@/utils/dictionary'
import http from '@/api/freight'
import {hideExport} from '@/utils/tools'
// import cityData from './map-data/get-city-value.js'
import Cookies from 'js-cookie'
import dimensionPopover from "components/exportDate/daphne/popover.vue";
import cloneDeep from "lodash/cloneDeep";
import Util from "utils/util";
import get from "lodash/get";
import set from "lodash/set";
import dimensionDialog from "components/exportDate/daphne/dialog.vue";

var now = new Date()
now.setMonth(now.getMonth())

export default {
  name: 'home',
  components: {
    dimensionDialog,
    dimensionPopover,
    homeMap,
    mapCard,
    tabTon,
    detailsData
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    let value4 = Util.lastTime(new Date());
    let arr = value4.split('-')
    let dimObj = {
      year: arr[0],
      month: arr[1],
      type: "0",
    };
    let firstLoaded = true;
    return {
      priviceName: '',
      dimObj,//纬度对像
      firstLoaded,
      fuelTypeList,
      value4,
      fuelType: "",
      showExport:false,//控制批量导出
      hideExport: hideExport,
      showtip: false,
      dataType: 0, //tab切换
      moduleName:"registerTonVehicle",
      showDetails: false,
      path: 'carTonnage',
      titleArr: [
        {
          title: '',
          value: '',
          key: 'registSubtotal'
        },
        {
          title: '10吨以下',
          value: '',
          key: 'regist_0_10'
        },
        {
          title: '10(含)-25吨',
          value: '',
          key: 'regist_10_25'
        },
        {
          title: '25(含)-35吨',
          value: '',
          key: 'regist_25_35'
        },
        {
          title: '35吨(含)以上',
          value: '',
          key: 'regist_35'
        }
      ],
      progressNum: 0, //进度条进度
      provinCode: '',
      provinName: '',
      mark: false, //是否显示遮罩层
      mapRangeList: [], //地图图例
      year: 0,
      month: 0,
      monTime: now,
      dataItem: [], //地图数据
      nounArr: ['第1-3名', '第4-7名', '第8-12名', '第13-18名', '第19-31名'] //地图图例汉字
    }
  },
  watch: {},
  computed: {},
  created() {
    if (Cookies.get('userType') != 2) {
      let time = this.monTime
      this.year = time.getFullYear()
      this.month = time.getMonth()
      this.initTit()
      this.initData()
    }
  },
  methods: {
    hideExport1(){
      this.showExport=false
      this.initData()
    },
    changeDimension(e) {
      if (e.isOk) {
        this.value4 = e.year + "-" + e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      this.initData()
    },
    getNewDimObj() {
      if (Cookies.get('userType') == 2) {
        this.dimObj.month = '0' + (Number(this.dimObj.month) - 1);
      }
      return cloneDeep(this.dimObj)
    },
    getDetails(index, code, name) {
      this.priviceName = name
      this.provinCode = code
      this.provinName = name
      this.showDetails = true
    },
    closeDetails() {
      this.showDetails = false
      this.initTit()
      this.initData()
    },
    changeType(num) {
      this.dataType = num
      this.initData()
    },
    changeFuelType() {
      this.initTit()
      this.initData()
    },
    initTit() {
      // let that = this
      // let energyType = getFuelTypeCode(this.fuelType);
      // http.carTonnageAll({
      //     year: null,
      //     month: null,
      //     energyType,
      //   }).then(e => {
      //     let arr = [...that.titleArr]
      //     arr[0].value = e.data.registSubtotal
      //     arr[1].value = e.data.regist_0_10
      //     arr[2].value = e.data.regist_10_25
      //     arr[3].value = e.data.regist_25_35
      //     arr[4].value = e.data.regist_35
      //     that.titleArr = [...arr]
      //     that.month = e.data.month
      //     that.year = e.data.year
      //   })
      let that = this
      let energyType = getFuelTypeCode(this.fuelType)
      let arr = that.value4.split('-')
      let type = get(this, "dimObj.type", "0")
      http.carTonnageAll({
        year: arr[0],
        month: arr[1],
        energyType,
        type
      })
          .then(e => {
            let arr = [...that.titleArr]
            arr[0].value = e.data.registSubtotal
            arr[1].value = e.data.regist_0_10
            arr[2].value = e.data.regist_10_25
            arr[3].value = e.data.regist_25_35
            arr[4].value = e.data.regist_35
            that.titleArr = [...arr]
            that.month = e.data.month
            that.year = e.data.year
          })
    },
    initData() {
      let that = this
      let energyType = getFuelTypeCode(this.fuelType);

      let arr = that.value4.split('-')
      let type = get(this, "dimObj.type", "0")
      let firstPageLoad = this.firstLoaded ? 1 : 0;
      http
          .carTonnage({
            condition: that.titleArr[that.dataType].key,
            energyType,
            registYear: arr[1] == '00' ? arr[0] - 1 : arr[0],
            registMonth: arr[1] == '00' ? '12' : arr[1],
            type,
            firstPageLoad,
          })
          .then(e => {
            if (this.firstLoaded) {
              this.firstLoaded = false;
              if (e.data && e.data.time) {
                that.value4 = e.data.time;
                let arr = that.value4.split('-')
                set(this, "dimObj.year", arr[0])
                set(this, "dimObj.month", arr[1])
                this.$refs.objDimensionPopover.setCtrlValue();
              }
            }
            that.initTit();
            if (e.data && e.data.mapRangeList) {
              for (let i = 0; i < e.data.mapRangeList.length; i++) {
                // if (e.data.mapRangeList[i].end == -1) {
                e.data.mapRangeList[i].label = that.nounArr[i]
                //     e.data.mapRangeList[i].start + ' 以上'
                //   delete e.data.mapRangeList[i].end
                // }
              }
              that.mapRangeList = [...e.data.mapRangeList]
              that.dataItem = that.handleSeriesData({
                data: e.data.resultList,
                index: that.dataType
              })
              this.showtip = false
            } else {
              that.dataItem = []
              that.mapRangeList = [{end: 0, start: 0, label: "无"}]
              this.showtip = true
            }
          })
    },
    exportDate() {
      // this.$alert('截止指定日期的货运平台入网车辆数总和。', '', {
      //   confirmButtonText: '知道了',
      //   callback: action => {
      //     if(action==="cancel") return;
      //     let that = this
      //     that.mark = true
      //     let reqId = Cookies.get('user')
      //     window.times = setInterval(function() {
      //       http.progress({ reqId }).then(e => {
      //         that.progressNum = e.data.percent
      //         if (e.data.percent >= 100) {
      //           that.mark = false
      //           that.progressNum = 0
      //           clearInterval(window.times)
      //         }
      //       })
      //     }, 100)
      //     reqId += new Date() * 1
      //     window.location.assign(
      //       http.carTonnageExport({
      //         registYear: this.year,
      //         registMonth: this.month,
      //         reqId
      //       })
      //     )
      //   }
      // })

      this.showExport = true
      return
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      window.times = setInterval(function () {
        http.progress({reqId}).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(window.times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      let arr = that.value4.split('-')
      window.location.assign(
          http.carTonnageExport({
            registYear: arr[0],
            registMonth: arr[1],
            reqId
          })
      )
    },
    handleSeriesData({index = 0, data}) {
      let that = this
      let arrs = JSON.stringify(data)
      let handleArr = JSON.parse(arrs)
      handleArr.forEach(e => {
        e.name = e.registProvince.slice(0, e.registProvince.length - 1)
        if (index == 0) {
          e.value = e.registSubtotal
        } else if (index == 1) {
          e.value = e.regist_0_10
        } else if (index == 2) {
          e.value = e.regist_10_25
        } else if (index == 3) {
          e.value = e.regist_25_35
        } else if (index == 4) {
          e.value = e.regist_35
        } else {
          e.value = e.registSubtotal
        }
      })
      return handleArr
    }
  }
}
</script>
